import { Button, Modal, ModalContent, ModalFooter } from 'components/lib';
import AppStoreContext from 'contexts/AppStoreContext';
import { buttons } from 'copy/copy';
import React, { ReactElement } from 'react';
import './modals.css';

interface Props {
  header: string;
  content: React.ReactNode;
  onClose: () => void;
}

const ConnectionErrorModal = (props: Props): ReactElement => {
  const { content, header, onClose } = props;

  return (
    <Modal size="small" onDismiss={onClose} title={header}>
      <div id="connection-error-modal">
        <ModalContent>{content}</ModalContent>
        <ModalFooter>
          <Button
            id="connection-error-modal-close-btn"
            onClick={onClose}
            size="large"
            variant="tertiary"
          >
            {buttons.close}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default ConnectionErrorModal;
